const FORM_ADD = 'add'
const FORM_REPLACE = 'replace'
const FORM_REMOVE = 'remove'

export {FORM_ADD, FORM_REMOVE, FORM_REPLACE}
